/** Estrae fotogrammi da un video locale (blob/url) via canvas: usato per anteprime e copertine clip. */
export function createFrameGrabber(url) {
  const v = document.createElement("video");
  v.src = url;
  v.muted = true;
  v.playsInline = true;
  v.preload = "auto";
  const cv = document.createElement("canvas");
  const ready = new Promise((res) => {
    if (v.readyState >= 2) res();
    else {
      v.onloadeddata = () => res();
      setTimeout(res, 4000);
    }
  });

  return {
    async grab(time, w = 108, h = 192) {
      await ready;
      cv.width = w;
      cv.height = h;
      const ctx = cv.getContext("2d");
      if (Math.abs(v.currentTime - time) > 0.02) {
        await new Promise((res) => {
          let done = false;
          const fin = () => { if (!done) { done = true; res(); } };
          v.onseeked = fin;
          setTimeout(fin, 1500);
          v.currentTime = time;
        });
      }
      ctx.drawImage(v, 0, 0, w, h);
      return cv.toDataURL("image/jpeg", 0.72);
    },
    destroy() {
      v.removeAttribute("src");
      try { v.load(); } catch { /* ignore */ }
    },
  };
}
